module.exports = __webpack_public_path__ + "img/logo.46bba6f9.png";